import React, {
  useCallback,
  useContext,
} from 'react';

import useComponentMounted from '../../../../../hooks/useComponentMounted';
import useCurrentLoggedInUser from '../../../../../hooks/useCurrentLoggedInUser';
import useSessionStore from '../../../../../hooks/useSessionStore';
import useToast from '../../../../hooks/useToast';
import { PillButton } from '../../../../../components/Button/ActionButtons';

import MessagingBroadcastModal from '../MessagingBroadcastModal';
import ChatContext from '../../../../context/ChatContext';
import LoggedInUserContext from '../../../../../context/LoggedInUserContext';
import {
  StyledContainer,
  StyledBroadcastIcon,
} from './styles';
import text from './text.json';

const MessagingBroadcast = () => {
  const {
    isBroadcastModalOpen: isModalOpen,
    setIsBroadcastModalOpen: setIsModalOpen,
  } = useContext(ChatContext);

  const {
    userDoc: {
      isCAM: isLoggedInUserCAM,
    },
  } = useContext(LoggedInUserContext);

  const { isCurrentLoggedInUserInPath } = useCurrentLoggedInUser();
  const { isCoachAssistant } = useSessionStore();
  const { showToast } = useToast();
  const isComponentMountedRef = useComponentMounted();

  const onBroadcastMessageButtonClick = () => {
    setIsModalOpen(true);
  };

  const onModalDismiss = () => {
    if (isComponentMountedRef.current) {
      setIsModalOpen(false);
    }
  };

  const showErrorToast = useCallback((errorMessage = '') => {
    const toastText = errorMessage || text.broadcastMessageError;
    showToast(toastText, { error: true });
  }, [
    showToast,
  ]);

  return (
    <StyledContainer>
      <PillButton
        onClick={onBroadcastMessageButtonClick}
        disabled={!isCurrentLoggedInUserInPath && !isCoachAssistant && !isLoggedInUserCAM}
        icon={<StyledBroadcastIcon />}
      >
        {text.broadcastMessageButtonLabel}
      </PillButton>
      {isModalOpen && (
        <MessagingBroadcastModal
          isOpen={isModalOpen}
          onDidDismiss={onModalDismiss}
          showMessageError={showErrorToast}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </StyledContainer>
  );
};

export default MessagingBroadcast;
